import script from "./GlobalAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalAlert.vue?vue&type=script&setup=true&lang=js"

import "./GlobalAlert.vue?vue&type=style&index=0&id=aea6d258&lang=css"

const __exports__ = script;

export default __exports__